import * as angular from 'angular';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { IProductSearchFilter } from '../api';
import { RetailerService } from '../api/retailer.service';
import {
    ClassificationCategoryListItem,
    CreateNfcExportRequest,
    CreateNfcOperationRequest,
    CreateNfcOperationResponse,
    DeletedStickersRequest,
    DeleteStickerRequest,
    EntityItem,
    NfcOperationPagingResult,
    NfcOperationsRequest,
    NfcStickerPagingResult,
    NfcStickerRequest, NfcStickerShortPagingResult, PlaceListShortModel, PlaceListShortModelPagingResult, StoreFindFilter
} from '../core';
import { IProductSearchItem, IProductSearchPagingResult } from '../products/models';

export class NfcRetailerStickersService {
    static $inject = ['http', 'retailerService'];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService    ) { }

    checkStickersAvailable(stickerNumberList: string[], entityID: string): angular.IPromise<void> {
        return this.http.post<void>(this.retailerService.checkStickersAvailable(), { stickerNumberList: stickerNumberList, entityID: entityID });
    }

    checkCanEditStickers = () => {
        return this.http.get<boolean>(this.retailerService.checkCanEditStickers());
    }

    getActiveStickers = (query: NfcStickerRequest) => {
        return this.http.get<NfcStickerPagingResult>(this.retailerService.activeStickers(), { params: query });
    }

    getDeletedStickers = (query: DeletedStickersRequest) => {
        return this.http.get<NfcStickerShortPagingResult>(this.retailerService.deletedStickers(), { params: query });
    }

    deleteSticker = (query: DeleteStickerRequest) => {
        return this.http.delete(this.retailerService.deleteSticker(), {params: query});
    }

    restoreSticker = (query: DeleteStickerRequest) => {
        return this.http.post(this.retailerService.restoreSticker(), null, {params: query});
    }

    getFreeStickersCount = () => {
        return this.http.get<number>(this.retailerService.freeStickersCount());
    }

    getOperations = (query: NfcOperationsRequest) => {
        return this.http.get<NfcOperationPagingResult>(this.retailerService.getOperations(), { params: query });
    }

    createOperation = (query: CreateNfcOperationRequest) => {
        return this.http.post<CreateNfcOperationResponse>(this.retailerService.createOperation(), query);
    }

    validateProductsAndCategories = (productIDs: number[], categoryIDs: number[]) => {
        let request = {
            productIDs: productIDs,
            categoryIDs: categoryIDs
        };
        return this.http.get<EntityItem[]>(this.retailerService.validateProductsAndCategories(), { params: request });
    }

    validateLocations = (placesIDs: number[]) => {
        return this.http.get<EntityItem[]>(this.retailerService.validatePlaces(), { params: placesIDs });
    }

    getLocations = (settings: StoreFindFilter) => {
        return this.http.get<PlaceListShortModelPagingResult>(this.retailerService.findStores(), { params: settings });
    }

    getAllLocations = () => {
        return this.http.get<PlaceListShortModel[]>(this.retailerService.fetchAllPlaces());
    }

    getProducts(filter: IProductSearchFilter) {
        return this.http.get<IProductSearchPagingResult>(this.retailerService.findProducts(), { params: filter });
    }

    getAllProducts = () => {
        return this.http.get<IProductSearchItem[]>(this.retailerService.fetchAllProducts());
    }

    getClassificationCategoriesForRetailer = () => {
        return this.http.get<ClassificationCategoryListItem[]>(this.retailerService.classificationCategoriesForRetailer());
    }

    exportCSV = (query: CreateNfcExportRequest) : any => {
        return this.http.post<number>(this.retailerService.exportCSV(), query);
    }

}

angular
    .module('naut')
    .service('nfcRetailerStickersService', NfcRetailerStickersService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/nfc-retailer-stickers.service.ts